import React from 'react';
import { GridItem } from '../GridItem';
import { ThumbnailInLoadingState } from '../../GameThumbnails/ThumbnailInLoadingState';
import { useSelector } from 'react-redux';
import { WinnersLoadingInGrid } from '../WinnersLoadingInGrid';
import { CasinoGamesGridContainer } from '../CasinoGamesGridContainer';

/**
 * Component for showing grid loader until platform games will be ready
 */
export const GridInLoadingState = ({
    amountOfLoadingItems = 56,
    showWinnersLoader,
}) => {
    const { isMobile } = useSelector((state) => state.app);

    return (
        <CasinoGamesGridContainer>
            {!isMobile && showWinnersLoader && <WinnersLoadingInGrid />}

            {(new Array(amountOfLoadingItems))
                .fill(undefined)
                .map((value, index) => {
                    return (
                        <GridItem key={index}>
                            <ThumbnailInLoadingState />
                        </GridItem>
                    );
                })
            }
        </CasinoGamesGridContainer>
    );
};
